import { Component, OnInit, ViewContainerRef, ElementRef, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { JobStatus } from '../../../shared/models/jobStatus.model';
import { Observable } from 'rxjs';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


@Component({
  selector: 'app-create-job-status',
  templateUrl: './create-job-status.component.html',
  styleUrls: ['./create-job-status.component.css']
})
export class CreateJobStatusComponent implements OnInit {


  colDefs;
  gridApi;
  gridColumnApi;
  SearchValue;
  rowData: any;
  private frameworkComponents;
  paginationPageSize: number;
  defaultColDef: { resizable: boolean; };
  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  modalRef: BsModalRef;
  model: JobStatus;
  gridOptions: any;
  job_status: any;

  initialCount = 0; // Put this in the master -> for child component
  public count;

  constructor(private httpclient: HttpClient, private router: Router, route: ActivatedRoute,
    private modalService: BsModalService,
    public toastr: HotToastService, vcr: ViewContainerRef
    , private _demoService: DemoService, public gfunc: GlobalFunctionsService
  ) { 


// login vars
this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
console.log('sessionUserId: ', this.currentUserVAR.user_id );
console.log('sessionUsername: ', this.currentUserVAR.username );
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;

  }

  ngOnInit() {

    this.colDefs = [

      {headerName: 'ID', field: 'job_status_id',  filter: 'agNumberColumnFilter',
      width: 60},

      {headerName: 'Name', field: 'job_status_name', filter: 'agTextColumnFilter',
       width: 100
    },
      {headerName: 'Description', field: 'job_status_description',  filter: 'agNumberColumnFilter',
      width: 600,  resizable: true}
      ];
this.frameworkComponents = {

};
this.paginationPageSize = 30;
this.defaultColDef = { resizable: true };


this.model = new JobStatus();


this.getJobStatusNames();

  }

  private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    fetch(this.gfunc.apiURL + '/api/job/status')
    .then(result => result.json())
    .then(rowData => this.rowData = rowData);
  }

  scrambleAndRefreshAll() {
    this.gridApi.refreshCells();
  }

  
  selectJob(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  
  }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.getJobStatusNames();
  // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


sendTypeID(id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count = id;
  this.initialCount = id;
// console.log('sending ID:' + this.count);

}


createJobStatus(model) {
  this._demoService.createJobStatus(model).subscribe(
     data => { this.job_status = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Status Created');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(model.trace_id);
   // return true;
  //  this.scrambleAndRefreshAll();
  this.getJobStatusNames();
  //  this.router.navigate(['admin/jobs/create-job-status']);
     },
     error => {
       // console.error('Error saving Trace Updates!');
      // return console.log(error);
      //  this.scrambleAndRefreshAll();
      this.toastr.success('Status Created');
  this.getJobStatusNames();
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}







}
